module.exports = __webpack_public_path__ + "static/media/c31pro-wifi.281f6554.png";